export default function dateFormatter(date) {
    const ONE_DAY = 24 * 60 * 60 * 1000;
    const oneDayAgo = new Date(Date.now() - ONE_DAY);
    if (date > oneDayAgo) {
        const diff = Date.now() - date.getTime();
        const minutes = Math.floor(diff / 60000);
        if (minutes < 60) {
            return `${minutes} min ago`;
        }
        const hours = Math.floor(diff / 3600000);
        return `${hours} hrs ago`;
    }
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
}
